"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utilitná funkcia pre naformátovanie username
 * @param {User} - Objekt používateľa
 * @returns {string} - Naformátované meno
 * @alias formatUserName
 * @example
 * ```javascript
 * import formatUserName from 'utilities/lib/formatUserName';
 *
 * console.log(formatUserName({
 *   name: 'Abc',
 *   surname: 'Xyz',
 *   titles: {
 *     before: 'Qwe.',
 *     after: 'Def.',
 *   },
 * })); // Qwe. Abc Xyz Def.
 * ```
 */
exports.default = (function (obj) {
    if (obj && typeof obj === 'object') {
        var parts = [];
        if (obj.titles && obj.titles.before) {
            parts.push(obj.titles.before);
        }
        if (obj.name) {
            parts.push(obj.name);
        }
        if (obj.middle_name) {
            parts.push(obj.middle_name);
        }
        if (obj.surname) {
            parts.push(obj.surname);
        }
        if (obj.titles && obj.titles.after) {
            parts.push(obj.titles.after);
        }
        return parts.join(' ');
    }
    return '';
});
